package pl.decks.personal.extensions

import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues

fun <T> responsiveValue(base: T, sm: T = base, md: T = sm, lg: T = md, xl: T = lg, xxl: T = xl): ResponsiveValues<T> =
    ResponsiveValues(base, sm, md, lg, xl, xxl)

fun <T> ResponsiveValues<T>.fromBreakpoint(breakpoint: Breakpoint): T = when (breakpoint) {
    Breakpoint.ZERO -> this.base
    Breakpoint.SM -> this.sm
    Breakpoint.MD -> this.md
    Breakpoint.LG -> this.lg
    Breakpoint.XL -> this.xl
    Breakpoint.XXL -> this.xxl
}
